import { MoveLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {FC, ReactNode} from "react";

interface GoBackHeaderProps {
    title?: string;
    icon?: ReactNode;
    onBackPress?: () => void;
}

const GoBackHeader: FC<GoBackHeaderProps> = ({title,onBackPress , icon}) => {
    const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-4 w-full py-4 sm:py-4 flex items-center mb-2 z-50">
      <div className="rounded-full w-12 h-12 bg-primary flex items-center justify-center">
        <button
          onClick={() => {
            if (onBackPress) {
              onBackPress();
            } else {
              navigate(-1);
            }
          }}
        >
            {icon || <MoveLeft color="#fff" className="w-6 h-6 "/>}        </button>
      </div>
      <p className="font-bold text-2xl ml-4">{title}</p>
    </header>
  );
};

export default GoBackHeader;
